import InfoDialog from '@ovComponents/2-component/infoDialog/infoDialog';
import { additionalInfo } from '@ovComponents/4-module/configurableOptionFields/additionalInfo';
import { Typography } from 'hephaestus/web';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { useLocalization } from '../../../../../hooks/useLocalization';
import type { MultiPortfolioDepositProps } from './multiPortfolioDeposit';

export type MultiPortfolioDepositHeaderProp = Pick<
  MultiPortfolioDepositProps,
  'options'
>;

export const MultiPortfolioDepositHeader = ({
  options,
}: MultiPortfolioDepositHeaderProp) => {
  const { translateBackendString } = useLocalization();
  const subtitleInfo = additionalInfo(
    translateBackendString,
    options?.subtitle?.additionalInfo,
  );

  return (
    <>
      <Typography
        variant='displayLarge'
        sx={{ mt: 1, mb: options?.subtitle ? 0 : 2 }}
      >
        {translateBackendString(options?.title)}
      </Typography>
      {options?.subtitle && (
        <Typography variant='bodyLarge' component='div' sx={{ mb: 3 }}>
          <ReactMarkdown remarkPlugins={[remarkGfm]} linkTarget={'_blank'}>
            {translateBackendString(options?.subtitle)}
          </ReactMarkdown>
          {subtitleInfo && <InfoDialog information={subtitleInfo} />}
        </Typography>
      )}
    </>
  );
};
